import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../apiConfig";

const UserProfile = () => {
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        console.error("No authentication token found in localStorage");
        setError("Authentication token missing");
        setLoading(false);
        return;
      }
  
      try {
        const response = await fetch(`${API_BASE_URL}/UpdateProfile/GetProfile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
  
        console.log("Response status:", response.status);
        console.log("Response headers:", [...response.headers]);
  
        if (!response.ok) {
          let errorMessage = "Failed to fetch profile data";
          try {
            const errorData = await response.json();
            console.error("Error response body:", errorData);
            errorMessage = errorData.message || errorMessage;
          } catch (jsonError) {
            console.error("Error parsing response as JSON:", jsonError);
          }
          throw new Error(errorMessage);
        }
  
        const data = await response.json();
        console.log("Profile data:", data);
  
        setProfile({
          name: data.name,
          email: data.email,
          phone: data.number,
          address: data.address,
        });
      } catch (err) {
        console.error("Error fetching profile:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchProfile();
  }, []);
  

  // Handle changes to input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const authToken = localStorage.getItem("authToken");

      try {
        const payload = {
          name: profile.name,
          email: profile.email,
          number: profile.phone,
          address: profile.address,
        };
        
        const response = await fetch(`${API_BASE_URL}/UpdateProfile/Update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(payload), // Send the correct payload
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update profile");
      }

      alert("Profile updated successfully!");
    } catch (err) {
      console.error("Error updating profile:", err.message);
      alert(err.message || "Something went wrong");
    }
  };

  // Render loading, error, or form
  return (
    <>
      <div className="content-wrapper">
        <div className="content">
          {/* Profile Card */}
          <div className="card card-default card-profile">
            <div className="card-body card-profile-body">
              <div className="profile-avata text-center">
                <button className="h5 d-block mt-3 mb-2">
                  {profile.name }
                </button>
                <button className="d-block text-color">
                  {profile.email }
                </button>
              </div>
            </div>
            <div className="card-footer card-profile-footer">
              <ul className="nav nav-border-top justify-content-center">
                <li className="nav-item">
                  <a className="nav-link" href="/dashboard/activities">
                    Activities
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link active" href="/dashboard/user-profile">
                    Edit profile
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Edit Profile Form */}
          <div className="row">
            <div className="col-xl-12">
              <div className="card card-default">
                <div className="card-header">
                  <h2 className="mb-5">Profile Settings</h2>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="card-body">
                    <div className="form-group row mb-6">
                      <label htmlFor="name" className="col-sm-4 col-lg-2 col-form-label">
                        Name
                      </label>
                      <div className="col-sm-8 col-lg-10">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={profile.name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-6">
                      <label htmlFor="email" className="col-sm-4 col-lg-2 col-form-label">
                        Email Id
                      </label>
                      <div className="col-sm-8 col-lg-10">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          value={profile.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-6">
                      <label htmlFor="phone" className="col-sm-4 col-lg-2 col-form-label">
                        Phone No
                      </label>
                      <div className="col-sm-8 col-lg-10">
                        <input
                          type="text"
                          className="form-control"
                          id="phone"
                          name="phone"
                          value={profile.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-6">
                      <label htmlFor="address" className="col-sm-4 col-lg-2 col-form-label">
                        Address
                      </label>
                      <div className="col-sm-8 col-lg-10">
                        <textarea
                          className="form-control"
                          id="address"
                          name="address"
                          value={profile.address}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>

                    
                     {/* {message && <div className="alert alert-info">{message}</div>}  */}

                    <div className="d-flex justify-content-end">
                      <button type="submit" className="btn btn-primary mb-2 btn-pill">
                        Update Profile
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;



// import React from 'react';
// import { Link } from 'react-router-dom';

// const UserProfile = () => {
//   return (
//    <>
//       <div className="content-wrapper">
//           <div className="content">
//             <div className="card card-default card-profile">
//               {/* <div className="card-header-bg" style="background-image:url(assets/img/user/user-bg-01.jpg)"></div> */}
//                 <div className="card-body card-profile-body">
//                   <div className="profile-avata text-center">
//                     <button className="h5 d-block mt-3 mb-2" href="#">Albrecht Straub</button>
//                     <button className="d-block text-color" href="#">albercht@example.com</button>
//                   </div>
//                 </div>

//                 <div className="card-footer card-profile-footer">
//                   <ul className="nav nav-border-top justify-content-center">
//                     <li className="nav-item">
//                       <Link className="nav-link" to="/dashboard/activities">Activities</Link>
//                     </li>
//                     <li className="nav-item">
//                       <Link className="nav-link active" to="/dashboard/user-profile">Edit profile</Link>
//                     </li>
//                   </ul>
//                 </div>
//               </div>

//               <div className="row">
//               <div className="col-xl-12">
//                 <div className="card card-default">
//                   <div className="card-header">
//                     <h2 className="mb-5">Profile Settings</h2>
//                   </div>
//                   <form>
//                   <div className="card-body">
//                       <div className="form-group row mb-6">
//                         <label for="occupation" className="col-sm-4 col-lg-2 col-form-label">Name</label>
//                         <div className="col-sm-8 col-lg-10">
//                           <input type="text" className="form-control" id="name" value="Nishidha" />
//                         </div>
//                       </div>
//                       <div className="form-group row mb-6">
//                         <label for="occupation" className="col-sm-4 col-lg-2 col-form-label">Email Id</label>
//                         <div className="col-sm-8 col-lg-10">
//                           <input type="email" className="form-control" id="email" value="albercht@example.com" />
//                         </div>
//                       </div>
//                       <div className="form-group row mb-6">
//                         <label for="occupation" className="col-sm-4 col-lg-2 col-form-label">Phone No</label>
//                         <div className="col-sm-8 col-lg-10">
//                           <input type="text" className="form-control" id="phone" value="9876543210"  />
//                         </div>
//                       </div>

//                       <div className="form-group row mb-6">
//                         <label for="com-name" className="col-sm-4 col-lg-2 col-form-label">Address</label>
//                         <div className="col-sm-8 col-lg-10">
//                         <textarea placeholder="Address" name="address" className="form-control" value="Address, sjd jh cjc jfc "></textarea>
//                         </div>
//                       </div>
                  
//                       <div className="col-md-12">
//                         <Link className="text-blue" href="/signin">Change Password</Link>
//                       </div>
                  
//                       <div className="d-flex justify-content-end">
//                         <button type="submit" className="btn btn-primary mb-2 btn-pill">Update Profile</button>
//                       </div>
//                     </div>
//                   </form>
//                 </div>
//               </div>        
//             </div>
//           </div>
//         </div>      
//    </>
//   );
// };

// export default UserProfile;
